module.exports = __webpack_public_path__ + "img/AED.2c647bfd.svg";